import { store } from "store/index";
import { isWhiteLabel } from "./whiteLabel";

// Default per-feature toggles for white-label deployments. Seeded into
// Redux on the first load (see white-label bootstrap in ReactRouteAll)
// and persisted thereafter; partner-specific overrides arrive via the
// same Redux slice once the backend ships per-partner config.
const DEFAULT_FEATURES = {
  notification: false,
  explanationVideo: true,
  fullParagraphExplanation: true,
  secret: false,
  liveSession: false,
};

export const getDefaultFeatures = () =>
  isWhiteLabel() ? { ...DEFAULT_FEATURES } : null;

// Module permissions (notification, explanationVideo, fullParagraphExplanation,
// secret, liveSession) only ever restrict white-label partners. On a non
// white-label (LA) build every module is always enabled — short-circuit before
// touching the `features` slice so a stale/persisted value can never switch a
// module off for LA users.
export const isFeatureEnabled = (key) => {
  if (!isWhiteLabel()) return true;
  const features = store.getState().features ?? getDefaultFeatures();
  if (!features) return true;
  return features[key] !== false;
};

export { DEFAULT_FEATURES };
